'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$151(ps$86) {
  this.a6T = null;
  this.a6T = ps$86;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$151 as $c_Lmealorama_jsonCodecs$package$$anon$151 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$151.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$151;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$151() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$151 as $h_Lmealorama_jsonCodecs$package$$anon$151 };
$h_Lmealorama_jsonCodecs$package$$anon$151.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6T.a.length;
});
$p.g = (function(i) {
  return this.a6T.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$151 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$151, "mealorama.jsonCodecs$package$$anon$151", ({
  J3: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$151 as $d_Lmealorama_jsonCodecs$package$$anon$151 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$151.js.map
